import { Helmet } from 'react-helmet-async';
import { toSeoAbsoluteUrl } from '../../utils/seoSiteUrl';

interface OrganizationSchemaProps {
  organization: {
    name: string;
    description?: string;
    url: string;
    logo?: string;
    email?: string;
    telephone?: string;
    sameAs?: string[]; // Social media URLs
  };
}

/**
 * OrganizationSchema component generates JSON-LD structured data for Organisation pages.
 * Enables rich organisation info in search results and better knowledge graph integration.
 */
export default function OrganizationSchema({ organization }: OrganizationSchemaProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: organization.name,
    ...(organization.description && { description: organization.description }),
    url: toSeoAbsoluteUrl(organization.url),
    ...(organization.logo && { logo: toSeoAbsoluteUrl(organization.logo) }),
    ...(organization.email && { email: organization.email }),
    ...(organization.telephone && { telephone: organization.telephone }),
    ...(organization.sameAs && organization.sameAs.length > 0 && { sameAs: organization.sameAs }),
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
}
